// extracted by mini-css-extract-plugin
module.exports = {"checkboxRoot":"SearchEntry_checkboxRoot__20YxK","checkboxLabel":"SearchEntry_checkboxLabel__7Elr5"};